import React from "react";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&display=swap');
  *{box-sizing:border-box;margin:0;padding:0;}
  body{font-family:'DM Sans',sans-serif;background:#edf0f9;}
  ::-webkit-scrollbar{width:5px;} ::-webkit-scrollbar-thumb{background:#b8c2de;border-radius:4px;}
  @keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
  @keyframes fadeIn{from{opacity:0}to{opacity:1}}
  @keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}
  @keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
  .fu{animation:fadeUp .38s cubic-bezier(.22,1,.36,1) both;}
  .fi{animation:fadeIn .25s ease both;}
  .ch{transition:transform .2s,box-shadow .2s;}
  .ch:hover{transform:translateY(-2px);box-shadow:0 14px 44px rgba(11,19,51,.12)!important;}
  .ni{transition:all .14s ease;} .ni:hover{background:rgba(14,201,164,.08);}
  .btn{transition:all .16s ease;cursor:pointer;font-family:'DM Sans',sans-serif;border:none;}
  .btn:hover:not(:disabled){transform:translateY(-1px);}
  .inp{outline:none;transition:border-color .18s,box-shadow .18s;font-family:'DM Sans',sans-serif;}
  .inp:focus{border-color:#0ec9a4!important;box-shadow:0 0 0 3px rgba(14,201,164,.14);}
  .ov{position:fixed;inset:0;background:rgba(8,12,36,.55);backdrop-filter:blur(6px);z-index:200;display:flex;align-items:center;justify-content:center;animation:fadeIn .18s ease;}
  .mb{background:#fff;border-radius:20px;padding:28px;width:500px;max-width:94vw;max-height:90vh;overflow-y:auto;animation:fadeUp .28s cubic-bezier(.22,1,.36,1);}
  table{border-collapse:collapse;width:100%;}
  th{text-align:left;font-size:11px;font-weight:600;letter-spacing:.5px;text-transform:uppercase;color:#7e89b0;padding:0 16px 10px;}
  td{padding:12px 16px;font-size:13px;border-top:1px solid #e8ecf5;color:#141e4f;}
  tr:hover td{background:#f4f6ff;}
  h1,h2,h3,h4{font-family:'Syne',sans-serif;}
  .tag{display:inline-flex;align-items:center;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;}
  .star{color:#f59e0b;font-size:13px;}
  .notif-dot{animation:pulse 1.5s infinite;}
  .plan-badge{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;}
  .ad-banner{background:linear-gradient(90deg,#f8f9ff,#eef0ff,#f8f9ff);background-size:200% 100%;animation:shimmer 3s infinite;border-radius:10px;border:1px solid #e0e7ff;}
  @media print {
    body * { visibility: hidden; }
    #ticket-print, #ticket-print * { visibility: visible; }
    #ticket-print { position: fixed; left: 50%; top: 0; transform: translateX(-50%); width: 72mm; background: white; }
  }
`;

export const FontLoader = () => React.createElement("style", null, CSS);

/* ── Palette ── */
export const C = {
  navy:"#0b1333", blue:"#4f6ef7", blueL:"#eef0ff",
  teal:"#0ec9a4", tealL:"#e0faf4", gold:"#f59e0b",
  green:"#22c78a", red:"#f04d4d", orange:"#f97316",
  purple:"#8b5cf6", bg:"#edf0f9", card:"#fff",
  border:"#e8ecf5", text:"#141e4f", muted:"#7e89b0"
};

/* ── ResiFlow Logo ── */
export const RFLogo = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
    <rect width="40" height="40" rx="10" fill="#4f6ef7"/>
    <path d="M10 28 C10 20 16 12 20 12 C24 12 26 16 22 20 C18 24 22 28 28 28"
      stroke="white" strokeWidth="3" strokeLinecap="round" fill="none"/>
    <circle cx="28" cy="28" r="3" fill="#0ec9a4"/>
    <circle cx="10" cy="28" r="2" fill="rgba(255,255,255,0.6)"/>
  </svg>
);

/* ── Static Data ── */